import Component from './component'
import {connect} from 'react-redux'

export default connect(null, null, null, { withRef: true })(Component)


// WEBPACK FOOTER //
// ./src/views/administrativo/vendas/container.js